// src/features/softwareLicenses/Routes.jsx
import { Route } from 'react-router-dom';
import ProtectedRoute from '../auth/Utils/ProtectedRoute';
import LicensesListPage from './pages/LicensesListPage';
import LicenseDetailsPage from './pages/LicenseDetailsPage';

export const SoftwareLicenseRoutes = () => (
  <Route path="software-licenses">
    <Route
      index
      element={
        <ProtectedRoute requiredScope="software_license:moderate">
          <LicensesListPage />
        </ProtectedRoute>
      }
    />
    <Route
      path=":licenseId"
      element={
        <ProtectedRoute requiredScope="software_license:moderate">
          <LicenseDetailsPage />
        </ProtectedRoute>
      }
    />
  </Route>
);